(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["teloven-process-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('teloven-process-carousel')) {
    customElements.define(
      'teloven-process-carousel',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.initialized === 'true') return;

          this.dataset.initialized = 'true';
          const track = this.querySelector('[data-process-track]');

          if (!track) return;

          this.querySelectorAll('[data-process-direction]').forEach((button) => {
            button.addEventListener('click', () => {
              const direction = Number(button.dataset.processDirection);
              const scrollAmount = track.clientWidth * 0.86;

              track.scrollBy({
                left: scrollAmount * direction,
                behavior: 'smooth',
              });
            });
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["teloven-skin-transformations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('teloven-skin-transformations')) {
    customElements.define(
      'teloven-skin-transformations',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.initialized === 'true') return;

          this.dataset.initialized = 'true';
          const track = this.querySelector('[data-transformations-track]');

          if (!track) return;

          this.querySelectorAll('[data-transformations-direction]').forEach((button) => {
            button.addEventListener('click', () => {
              const card = track.querySelector('.teloven-skin-transformations__card');
              const direction = Number(button.dataset.transformationsDirection);
              const gap = Number.parseFloat(window.getComputedStyle(track).gap) || 0;
              const scrollAmount = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.86;

              track.scrollBy({
                left: scrollAmount * direction,
                behavior: 'smooth',
              });
            });
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
